<script>
  import { tick } from 'svelte'

  const nextFrame = () => new Promise(rs => requestAnimationFrame(() => requestAnimationFrame(() => rs())))

  export let pingCount = 0
  /**
   * Specify the icon to render
   * @type {typeof import("carbon-icons-svelte/lib/Add16").default} [icon]
   */
  export let icon = undefined

  let lastPingCount = pingCount
  let flashing = false
  async function flash() {
    flashing = true
    await nextFrame()
    flashing = false
  }

  $: if (pingCount > lastPingCount) {
    lastPingCount = pingCount
    flash()
  }
</script>

<style>
  .bx--header__connectivity {
    height: 3rem;
    width: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #616161;
  }

  :global(.bx--header__connectivity .bx--header__connectivity-icon path) {
    transition: fill 2s ease;
  }
  :global(.bx--header__connectivity--active .bx--header__connectivity-icon path) {
    fill: lime;
    transition: fill 0.05s;
  }
</style>

<div
  class:bx--header__connectivity={true}
  class:bx--header__connectivity--active={flashing}
  {...$$restProps}
  on:click>
  <slot>
    <svelte:component
      this={icon}
      class="bx--header__connectivity-icon"
      />
  </slot>
</div>
